export default [
    // {
    //     icon: "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/3043de011f52cc3a2af1fb3111fc96b2.png",
    //     title: "随心购活动版",
    //     titleTag: "组合购玩法",
    //     featList: [
    //         '1. 商家基于订单数据洞察利用该工具配置组合商品',
    //         '2. 消费者挑选喜欢的商品，加入心愿单',
    //         '3. 挑选完成后，提示满减送礼的优惠，点击“去凑单”',
    //         '4. 商家在此处配置规则，智能推荐“凑单商品”',
    //         '5. 结束选购后生成礼盒，下单购买',
    //     ],
    //     marketFeats: [
    //         '提升店铺GMV',
    //         '提升客单价',
    //     ],
    //     applicableIndustriesList: [
    //         '所有行业'
    //     ],
    //     typeId: 0
    // },
    {
        icon: "http://enbrands-2.oss-cn-shanghai.aliyuncs.com/user/46eacb6ee9a8a84c6ea6b0886078a754.jpg",
        title: "大促搭配购工具版",
        titleTag: "大促搭配购玩法",
        featList: [
            '1. 商家基于订单数据洞察利用该工具配置组合商品',
            '2. 消费者挑选喜欢的商品，加入心愿单',
            '3. 挑选完成后，提示满减送礼的优惠，点击“去凑单”',
            '4. 商家在此处配置规则，智能推荐“凑单商品”',
            '5. 结束选购后生成礼盒，下单购买',
        ],
        marketFeats: [
            '提升店铺GMV',
            '提升客单价',
        ],
        applicableIndustriesList: [
            '所有行业'
        ],
        typeId: 1
    }
];
